import TreatmentActivity from './treatment-activity'

export default TreatmentActivity
